import { Box, CircularProgress, Typography } from "@mui/material";

interface Props {
    title?: string;
    loading?: boolean;
    isEmpty?: boolean;
}

export function EmptyList({ title, loading, isEmpty }: Props) {
    return (
        <Box
            height="100%"
            display="flex"
            alignItems="center"
            justifyContent="center"
        >
            {loading && <CircularProgress />}

            {isEmpty && !loading && (
                <Typography variant="body2" color="text.secondary">
                    {title || "Lista vazia"}
                </Typography>
            )}
        </Box>
    );
}
